/**
 * Import Dependency
 */
import {createI18n} from 'vue-i18n'

import en from './i18n/en_US.json'
import de from './i18n/de_DE.json'
// import cn from './i18n/zh_CN'

const messages = {
  en: en,
  de: de,
}

const i18nLocal = createI18n({
  legacy: false,
  allowComposition: true,
  locale: 'de',
  fallbackLocale: 'en',
  messages
})

/**
 * Export
 */
export const i18n = i18nLocal

// export default i18nLocal
